import { isNil } from "lodash-es";
import { ReactNode, createContext, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useComplexState } from "use-complex-state";
import { LMFProcessesReducer } from "../reducers/LMFProcessesReducer";

const LMFProcessesContext = createContext({
  state: LMFProcessesReducer.getInitialState(),
  actions: LMFProcessesReducer.actions,
});

export const useLMFProcessesContext = () => useContext(LMFProcessesContext);

export const LMFProcessesProvider = ({ children }: { children: ReactNode }) => {
  const [state, actions] = useComplexState({
    initialState: LMFProcessesReducer.getInitialState(),
    reducers: LMFProcessesReducer.caseReducers,
  });

  return (
    <LMFProcessesContext.Provider value={{ state, actions }}>
      {children}
    </LMFProcessesContext.Provider>
  );
};
